/**
 |--------------------------------------------------------------------------
 | CLIENT LOGGED IN ONLY : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const client_routes = [{
    path: '/c/company',
    component: require('pages/clients/company/company_record').default,
    name: 'c_company_record',
    meta: {requiresAuth: true, title: "Company Record", icon: "fas fa-building"}
}, {
    path: '/c/genius',
    component: require('pages/clients/company/genius').default,
    name: 'c_genius',
    meta: {requiresAuth: true, title: "Genius Money", icon: "far fa-building"}
}, {
    path: '/c/v3',
    component: require('pages/clients/company/v3').default,
    name: 'c_v3',
    meta: {requiresAuth: true, title: "V3 Recruitment", icon: "far fa-building"}
}, {
    path: '/c/contracts',
    component: require('pages/clients/contracts/all_contracts').default,
    name: 'c_all_contracts',
    meta: {requiresAuth: true, title: "All Contracts", icon: "fas fa-file-contract"}
}, {
    path: '/c/orders',
    component: require('pages/clients/orders/all_orders').default,
    name: 'c_all_orders',
    meta: {requiresAuth: true, title: "All Orders", icon: "fas fa-list-alt"}
}, {
    path: '/c/orders/analysis',
    component: require('pages/clients/orders/orders_analysis').default,
    name: 'c_orders_analysis',
    meta: {requiresAuth: true, title: "Order Analsis", icon: "fas fa-sort-amount-up"}
}, {
    path: '/c/workers/all/assigned',
    component: require('pages/clients/workers/assigned_workers').default,
    name: 'c_assigned_workers',
    meta: {requiresAuth: true, title: "Assigned Workers", icon: "fas fa-handshake"}
}, {
    path: '/c/workers/all/clock_in_out_locations',
    component: require('pages/clients/workers/clock_in_out_locations').default,
    name: 'clock_in_out_locations',
    meta: {requiresAuth: true, title: "Live Activity", icon: "fas fa-clock"}
}, {
    path: '/c/workers/all/clock_in_out_details',
    component: require('pages/clients/workers/clock_in_out_details').default,
    name: 'clock_in_out_details',
    meta: {requiresAuth: true, title: "Live Activity", icon: "fas fa-clock"}
}, {
    path: '/c/workers/all/historic/assigned',
    component: require('pages/clients/workers/historic_assigned_workers').default,
    name: 'c_historic_assigned_workers',
    meta: {requiresAuth: true, title: "Assigned Workers", icon: "fas fa-handshake-alt-slash"}
}, {
    path: '/c/workers/workforce_analysis',
    component: require('pages/clients/workers/workforce_analysis').default,
    name: 'c_workforce_analysis',
    meta: {requiresAuth: true, title: "Workforce Analysis", icon: "fas fa-people-arrows"}
}, {
    path: '/c/timesheets/submit',
    component: require('pages/clients/timesheets/old/client_timesheets_submission').default,
    name: 'client_timesheets_submission',
    meta: {requiresAuth: true, title: "Submit Timesheets", icon: "fas fa-user-clock"}
}, {
    path: '/c/timesheets/historic',
    component: require('pages/clients/timesheets/old/client_timesheets').default,
    name: 'c_timesheet_historic',
    meta: {requiresAuth: true, title: "Historic Timesheets", icon: "fas fa-history"}
}, {
    path: '/c/timesheets/setup',
    component: require('pages/clients/timesheets/timesheet_setup').default,
    name: 'c_timesheet_setup',
    meta: {requiresAuth: true, title: "Timesheet Setup", icon: "fas fa-business-time"}
}, {
    path: '/c/timesheets/preferences',
    component: require('pages/clients/timesheets/timesheet_preferences').default,
    name: 'c_timesheet_preferences',
    meta: {requiresAuth: true, title: "Timesheet Preferences", icon: "fas fa-cogs"}
},

    // NEW

    {
        path: '/c/new/timesheets/submit',
        component: require('pages/clients/timesheets/timesheet_submit').default,
        name: 'c_timesheet_submit',
        meta: {requiresAuth: true, title: "Submit Timesheets", icon: "fas fa-user-clock"}
    },

    {
        path: '/c/new/timesheets/current',
        component: require('pages/clients/timesheets/timesheet_live').default,
        name: 'c_timesheet_live',
        meta: {requiresAuth: true, title: "Current Live Timesheet", icon: "fas fa-play"}
    }, {
        path: '/c/new/timesheets/additional_payments',
        component: require('pages/clients/timesheets/timesheet_additional_payments').default,
        name: 'c_timesheet_additional_payments',
        meta: {requiresAuth: true, title: "Additional payments Timesheets", icon: "fas fa-history"}
    }, {
        path: '/c/new/timesheets/historic',
        component: require('pages/clients/timesheets/timesheet_historic').default,
        name: 'c_timesheet_historics',
        meta: {requiresAuth: true, title: "Historic Timesheets", icon: "fas fa-history"}
    }, {
        path: '/c/new/timesheets/site_analysis',
        component: require('pages/clients/timesheets/timesheet_site_analysis').default,
        name: 'c_timesheet_site_analysis',
        meta: {requiresAuth: true, title: "Timesheet Site Analysis", icon: "fas fa-business-time"}
    }, {
        path: '/c/new/timesheets/worker_analysis',
        component: require('pages/clients/timesheets/timesheet_worker_analysis').default,
        name: 'c_timesheet_worker_analysis',
        meta: {requiresAuth: true, title: "Timesheet Worker Analysis", icon: "fas fa-user-clock"}
    },


    {
        path: '/c/r2/timesheets/select_period',
        component: require('pages/sunset/timesheets/client/timesheet_select_period.vue').default,
        name: 'c_timesheet_r2_select_period',
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-client',
            
        }
    }, {
        path: '/c/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date',
        component: require('pages/sunset/timesheets/client/timesheet_select_sites.vue').default,
        name: 'c_timesheet_r2_select_sites',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-client',
            
        }
    }, {
        path: '/c/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/order/:order_id/order_job/:order_job_id/workers',
        component: require('pages/sunset/timesheets/client/timesheet_site_workers.vue').default,
        name: 'c_timesheet_r2_select_site_worker',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-client',
            
        }
    }, {
        path: '/c/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/order/:order_id/order_job/:order_job_id/assign_workers',
        component: require('pages/sunset/timesheets/client/assign_worker.vue').default,
        name: 'c_timesheet_r2_assign_worker',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-client',
            
        }
    }, {
        path: '/c/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/order/:order_id/order_job/:order_job_id/workers/:timesheet_id',
        component: require('pages/sunset/timesheets/client/timesheet_edit_timesheet.vue').default,
        name: 'c_timesheet_edit_worker',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-client',
            
        }
    }, {
        path: '/c/new/timesheets/preview/:start_date/:end_date',
        component: require('pages/sunset/timesheets/client/timesheet_preview_all.vue').default,
        name: 'c_timesheet_r2_submit_preview',
        props: true,
        meta: {requiresAuth: true, title: "Preview Timesheets", icon: "fas fa-user-clock"}
    },

    {
        path: '/c/new/timesheets/worker_summary/:start_date/:end_date',
        component: require('pages/sunset/timesheets/client/timesheet_worker_summary.vue').default,
        name: 'c_timesheet_r2_worker_summary',
        props: true,
        meta: {requiresAuth: true, title: "View Worker Summary Timesheets", icon: "fas fa-user-clock"}
    },

    {
        path: '/c/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/import_timesheets',
        component: require('pages/sunset/timesheets/client/timesheet_import.vue').default,
        name: 'c_timesheet_r2_import_timesheets',
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    },
    {
        path: '/r2/client/timesheets/company/:company_id/imports/:importId/processing/:start_date/:end_date',
        name: 'c_timesheet_import_processing',
        component: () => import('pages/sunset/timesheets/import_processing.vue'),
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    }, {
        path: '/r2/client/timesheets/company/:company_id/imports/:importId/preview/:start_date/:end_date',
        name: 'c_timesheet_import_preview',
        component: () => import('pages/sunset/timesheets/import_preview.vue'),
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    },

    {
        path: '/x/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/import_timesheets',
        component: require('pages/sunset/timesheets/client/timesheet_import.vue').default,
        name: 'x_timesheet_r2_import_timesheets',
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    },
    {
        path: '/r2/legacy/timesheets/company/:company_id/imports/:importId/processing/:start_date/:end_date',
        name: 'x_timesheet_import_processing',
        component: () => import('pages/sunset/timesheets/import_processing.vue'),
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    },
    {
        path: '/r2/legacy/timesheets/company/:company_id/imports/:importId/preview/:start_date/:end_date',
        name: 'x_timesheet_import_preview',
        component: () => import('pages/sunset/timesheets/import_preview.vue'),
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    },

];
export default client_routes;
